// api.js testing 5
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://apiworkorder.perumdamtkr.com/api',
  // baseURL: 'http://127.0.0.1:8000/api',
  headers: {
    'ngrok-skip-browser-warning': 'any',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Interceptor untuk otomatis nambahin token ke header Authorization
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default api;
